import { createLazyFileRoute } from "@tanstack/react-router";

import { Section } from "@/features/admin/components/Section";
import { FieldSetDetailForm } from "@/features/admin/components/tubes/FieldSetDetailForm";

export const Route = createLazyFileRoute("/_auth/admin/tubes/field-sets/new")({
  component: NewFieldSetPage,
});

function NewFieldSetPage() {
  return (
    <div className="flex flex-col flex-1 max-w-3xl">
      <Section.Title>New field set</Section.Title>
      <FieldSetDetailForm />
    </div>
  );
}
